// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"746d7e08","680":"0914e24e","915":"d9162872"}[chunkId] + ".chunk.js";
};